//Browser storage key
export const GET_TOKEN_ACTION = "GET_TOKEN_ACTION";
export const CLEAN_INVITED_USER_DATA="CLEAN_INVITED_USER_DATA"
